/**
 * file : AllTournament/Total.jsx
 * 설명 : 토탈 정보
 */

import Icon1 from "assets/images/banner_icon1.png"
import Icon2 from "assets/images/banner_icon2.png"
import Icon3 from "assets/images/banner_icon3.png"

import $ from 'jquery';
import { Fnc } from "common/globals";
import { useEffect, useState } from 'react';
import { Search } from "components/Common/ApiCall";

export default function Total() {
  // 데이터
	const [datas, setDatas] = useState();
  // 조회
	useEffect(() => {
		Search('/total-sum', setDatas)
  }, [])
  //jQuery
  useEffect(() => {
    // 조회하여 데이터가 있는 경우에만적용
    if (!Fnc.Empty(datas)) { 
      // 클래스가 "counter"인 모든 요소를 선택
      const counters = $(".counter");
      const exposurePercentage = 100;
      const duration = 1000;
      const addCommas = true;

      function updateCounter($el, start, end) {
        let startTime;
        function animateCounter(timestamp) {
          if (!startTime) startTime = timestamp;
          const progress = (timestamp - startTime) / duration;
          const current = Math.round(start + progress * (end - start));
          const formattedNumber = addCommas ? current.toLocaleString() : current;
          $el.text(formattedNumber);
            
          if (progress < 1) {
            requestAnimationFrame(animateCounter);
          } else {
            $el.text(addCommas ? end.toLocaleString() : end);
          }
        }
        requestAnimationFrame(animateCounter);
      }

      $(window).on('scroll', function () {
        counters.each(function () {
          const $el = $(this);
          if (!$el.data('scrolled')) {
            const rect = $el[0].getBoundingClientRect();
            const winHeight = window.innerHeight;
            const contentHeight = rect.bottom - rect.top;
                  
            if (rect.top <= winHeight - (contentHeight * exposurePercentage / 100) && rect.bottom >= (contentHeight * exposurePercentage / 100)) {
              const start = parseInt($el.data("start"));
              const end = parseInt($el.data("end"));
              updateCounter($el, start, end);
              $el.data('scrolled', true);
            }
          }
        });
      });
    }
  }, [datas]);

  return (
    <div className="quick_total">
      <div className="box">
        <div><img src={Icon1} alt="총 상금 지불" /></div>
        <div>
          <p><b>₩</b> <span className="counter" data-start="0" data-end={!Fnc.Empty(datas) && datas.totla_pize_money}>0</span></p>
          <h2>총 상금 지불</h2>
        </div>
      </div>
      <div className="box">
        <div><img src={Icon2} alt="당첨자" /></div>
        <div>
          <p><span className="counter" data-start="0" data-end={!Fnc.Empty(datas) && datas.total_win_cnt}>0</span></p>
          <h2>당첨자</h2>
        </div>
      </div>
      <div className="box">
        <div><img src={Icon3} alt="온라인 플레이어" /></div>
        <div>
          <p><span className="counter" data-start="0" data-end={!Fnc.Empty(datas) && datas.total_user_cnt}>0</span></p>
          <h2>온라인 플레이어</h2>
        </div>
      </div>
    </div>
  )
}